export function capitalizeFirstLetter(input: string): string {
  if (!input) return input; // Проверяем, не пустая ли строка
  return (input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()) as string; // Приводим первую букву к верхнему регистру, остальное — к нижнему
}
